// extracted by mini-css-extract-plugin
export default {"header":"styles_header__zt5B7","title":"styles_title__iT0Ya","rateWrap":"styles_rateWrap__R4ybM","headerWrap":"styles_headerWrap__sGwTx"};